module.exports = __webpack_public_path__ + "img/menu.de7ca278.svg";